#import "./nut-email-address.graphql"

fragment EmailListItem on Email {
    id
    to {
        ...NutEmailAddress
    }
    cc {
        ...NutEmailAddress
    }
    from {
        ...NutEmailAddress
    }
    createdTime
    sentTime
    attachments {
        fileId
    }
    subject
    bodyText
    htmlUrl
    isShared
    isShareable
    isReplyable
    emailSequence {
        id
        messageCount
        emailSequenceTemplate {
            id
            name
        }
    }
    queuedEmail {
        messageNumber
        htmlUrl
    }
    trackedViewsCount
    isAutomatedReply
    isEmailAutomation
}
